var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCiTenant)?_c('img',{staticClass:"logo-login-wordmark my-2",attrs:{"src":require("@/assets/brand/wordmark.svg"),"alt":"The Dentistry","data-testid":"login-wordmark"}}):_c('div',{staticClass:"auth-brand-default"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }